import React, { useEffect, useState } from 'react';
import CertificationCharts from '../../CertificateTracking/Components/CertificationReport/CertificationCharts'
import ApplicantCharts from '../../../Components/CertificateTracking/Components/CertificateWork/Components/ApplicantCharts'
import { useAuth } from "oidc-react"
import { advanceSearch } from "../../../_helper/services/advanceSearchv2"
import { getUserId, getUserRole, ShowError, ShowSucess } from '../../../_helper/helper';

const CertGenCharts = () => {

    const [cdata, setCdata] = useState([])
    const [loading, setLoading] = useState(true)
    const { userData } = useAuth()
    const Role = getUserRole(userData)
    const [filteredCertifications, setFilteredCertifications] = useState([])

    const getData = async () => {
        setLoading(true)
        const params = [
            {
                columnName: "employee_id",
                value: userData?.profile?.EmployeeID,
                operator: "=",
                dataType: "bigint",
                logicOperator: "AND",
            },
        ]
        const checkAssignee = Role == "EEO" || Role == "POC" || Role == "PERSONAL-OFFICER"
        const tableName = checkAssignee ? "GET-ASSIGN-CERT-LIST" : "CERT-LIST"
        const payload = {
            tableName: tableName,
            searchParams: checkAssignee ? JSON.stringify(params) : "[]",
            columns: "*",
            location: "pmis-global",
            pageNumber: 1,
            pageSize: 100,
            sortData: "",
            additionalWhere: "",
            qID: 0,
        }
        try {
            const response = await advanceSearch(payload)
            const { results } = response
            setCdata(results)
            setFilteredCertifications(results)
            setLoading(false)
        } catch (error) {
            console.error("Error fetching data:", error)
            ShowError(error)
            setLoading(false)
        }
    }

    useEffect(() => {
        getData()
    }, [])

    return (
        <div>
            <CertificationCharts data={cdata} />
            <ApplicantCharts applicantData={cdata} />
        </div>
    )
}

export default CertGenCharts